import {Big, Float} from "./helper";
import {RowType} from "../../../components/Editable/FormItem/Rows/RowType";

export function calculateSubtotal(items) {
    let subtotalQuantityB = Big();
    let subtotalAmountB = Big();
    let subtotalDiscountB = Big();
    let subtotalTaxAmountB = Big();

    return items.map(record => {
        switch (record.type) {
            case RowType.subtotal:
            case RowType.subtitle: {
                // Now with amount, discount_amount and tax_amount
                const newRecord = {
                    ...record,
                    quantity: Float(subtotalQuantityB),
                    amount: Float(subtotalAmountB),
                    discount_amount: Float(subtotalDiscountB),
                    tax_amount: Float(subtotalTaxAmountB),
                };

                // Reset to 0
                subtotalQuantityB = Big();
                subtotalAmountB = Big();
                subtotalDiscountB = Big();
                subtotalTaxAmountB = Big();

                return newRecord;
            }
            default: {
                subtotalQuantityB = subtotalQuantityB.plus(record.quantity || 0);
                subtotalAmountB = subtotalAmountB.plus(record.amount || 0);
                // if (taxMode === 'inclusive')
                //     subtotalAmountB = subtotalAmountB.minus(record.tax_amount || 0);

                subtotalDiscountB = subtotalDiscountB.plus(record.discount_amount || 0);
                subtotalTaxAmountB = subtotalTaxAmountB.plus(record.tax_amount || 0);

                return record;
            }
        }
    });
}
